import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Logo from './Logo';
import ThemeToggle from './ThemeToggle';
import { CONTACT_PATH } from '../legal/company';

const NAV_LINKS = ['Features', 'How It Works', 'Pricing', 'FAQ'];

function sectionHref(label: string, onHome: boolean) {
  const hash = `#${label.toLowerCase().replace(/ /g, '-')}`;
  return onHome ? hash : `/${hash}`;
}

const MarketingNav: React.FC = () => {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const onHome = useLocation().pathname === '/';

  return (
    <nav className="nova-nav">
      <div className="nova-nav-inner">
        <Link to="/" aria-label="OnTheWeb home">
          <Logo />
        </Link>
        <div className="hidden md:flex items-center gap-1 ml-auto mr-4">
          {NAV_LINKS.map((item) => (
            <a
              key={item}
              href={sectionHref(item, onHome)}
              className="text-nova-text2 hover:text-nova-text text-sm px-3.5 py-1.5 rounded-md hover:bg-white/5 transition-all duration-300"
            >
              {item}
            </a>
          ))}
          <Link
            to={CONTACT_PATH}
            className="text-nova-text2 hover:text-nova-text text-sm px-3.5 py-1.5 rounded-md hover:bg-white/5 transition-all duration-300"
          >
            Contact
          </Link>
        </div>
        <div className="flex items-center gap-2 sm:gap-3 ml-auto md:ml-0">
          <ThemeToggle />
          {isAuthenticated ? (
            <>
              <button onClick={() => navigate('/dashboard')} className="btn-ghost hidden sm:inline-flex">
                Dashboard
              </button>
              <button onClick={() => navigate('/dashboard')} className="btn-primary">
                My Websites
              </button>
            </>
          ) : (
            <>
              <button onClick={() => navigate('/login')} className="btn-ghost hidden sm:inline-flex">
                Login or Signup
              </button>
              <button onClick={() => navigate('/login')} className="btn-primary">
                Get started
              </button>
            </>
          )}
          <button
            onClick={() => setMobileNavOpen((open) => !open)}
            aria-label="Toggle navigation menu"
            aria-expanded={mobileNavOpen}
            className="md:hidden flex items-center justify-center p-2 -mr-2 min-h-[44px] min-w-[44px] text-nova-text2 hover:text-nova-text"
          >
            {mobileNavOpen ? (
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            )}
          </button>
        </div>
      </div>
      {mobileNavOpen && (
        <div className="md:hidden absolute top-full inset-x-0 bg-nova-bg2 border-b border-nova-border shadow-nova-lg px-4 py-3 flex flex-col gap-1">
          {NAV_LINKS.map((item) => (
            <a
              key={item}
              href={sectionHref(item, onHome)}
              onClick={() => setMobileNavOpen(false)}
              className="text-nova-text2 hover:text-nova-text text-base px-3 py-2.5 rounded-md hover:bg-white/5 transition-all duration-300"
            >
              {item}
            </a>
          ))}
          <Link
            to={CONTACT_PATH}
            onClick={() => setMobileNavOpen(false)}
            className="text-nova-text2 hover:text-nova-text text-base px-3 py-2.5 rounded-md hover:bg-white/5 transition-all duration-300"
          >
            Contact
          </Link>
        </div>
      )}
    </nav>
  );
};

export default MarketingNav;
